var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.xCornerButton)?_c(_setup.OzBaseButton,{class:[
    'absolute',
    'top-0',
    'end-0',
    'bg-dark-ui-200',
    'hhover:bg-dark-ui-300',
    'w-20',
    'h-20',
    'flex',
    'items-start',
    'justify-end',
    'p-2',
    'cursor-pointer',
    'pointer-events-auto',
  ],style:({ clipPath: 'polygon(100% 0, 0 0, 100% 100%)' }),on:{"pointerdown":function($event){$event.stopPropagation();},"click":function($event){return _vm.$emit('click', $event)}}},[_c(_setup.OzIcon,{staticClass:"text-light-ui-200",attrs:{"name":_setup.iconName,"size":32}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }